//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import { ref } from '@nuxtjs/composition-api';
import { useUiState, useSalesCrm } from '~/composables';
import MoominWaveDivider from "~/themes/fiskarsMoominDefault/components/components/atoms/MoominWaveDivider/MoominWaveDivider.vue";
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
import NewsletterModal from '~/components/NewsletterModal.vue'
import analyticsEvents from "~/helpers/analytics/analyticsEvents";
import { AttemptType } from "~/helpers/analytics/types";
import LocaleSelectorButton from "~/components/LocaleSelectorButton.vue";

export default Vue.extend({
  name: 'MoominNewsletterSection',
  components: { LocaleSelectorButton, MoominWaveDivider, SfButton, NewsletterModal },
  props: {
    titleandtext: {
      type: Object,
      default: () => ({
        title: '',
        text: ''
      })
    },
    submitbuttontext: String,
    footersubscribebutton: String,
    buttontext: String,
    title: String,
    subtitle: String,
    firstname: String,
    lastname: String,
    email: String,
    ccmessage: String,
    firstnamevalidation: String,
    lastnamevalidation: String,
    emailvalidation: String,
    ccvalidaitonmessage: String,
    successmessage: String,
    failuremessage: String,
    successmessagetitle: String,
    failuremessagetitle: String,
    tcmessage: {
      type: Object,
      default: () => ({ value: '' })
    },
  },
  setup(){
    const showConfirmation = ref(false);
    const showError = ref(false);

    const resetStates = () => {
      showError.value = false;
      showConfirmation.value = false;
    }
    const { toggleNewsletterModal } = useUiState();
    const openModal = () => {
      resetStates();
      toggleNewsletterModal();
    }

    const {
      result: subscriptionResult,
      loading : loadingSubscription,
      signup : subscriberSignup,
      error : salesCRMError
    } = useSalesCrm('subscriberSignup');


    const submitEmail = async ( payload ) => {
      resetStates();
      const response = await subscriberSignup(payload);

      if(response.errorMessage) {
        analyticsEvents.newsletterSubscribe(AttemptType.FAILURE)
        resetStates();
      } else {
        analyticsEvents.newsletterSubscribe(AttemptType.SUCCESS)
        showConfirmation.value = true;
      }

    }

    return {
      subscriptionResult,
      loadingSubscription,
      salesCRMError,
      openModal,
      submitEmail,
      showConfirmation,
      showError,
    }
  }
})
